/**
 * Where a navigation item is available.
 *
 * The admin app operates in two scopes: a specific game is selected (routes are
 * prefixed with the gameId), or "global" / all-games mode (root-level routes).
 * Historically this was a hard fork into two separate side-nav components; this
 * enum lets a single nav model describe both.
 */
export enum NavScope {
  /** Only visible when a specific game is selected. */
  GameOnly,
  /** Only visible in global (all-games) mode. */
  GlobalOnly,
  /** Visible in both scopes; the route resolves per the active scope. */
  Both,
}
